import React from "react";
import "./TopBar.css";

function TopBar({ onSearch }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const query = e.target.value.trim();
      if (query && onSearch) {
        onSearch(query);
      }
    }
  };

  return (
    <header className="top-bar">
      <div className="logo">NAGARAM</div>
      <div className="search-container">
        <input
          type="text"
          id="search-input"
          placeholder="Search places or lat,lng..."
          onKeyDown={handleKeyDown}
        />
        <i className="fa-solid fa-magnifying-glass"></i>
      </div>
    </header>
  );
}

export default TopBar;
